import { render, staticRenderFns } from "./MobileIndex.vue?vue&type=template&id=2bc194e1&scoped=true"
import script from "./MobileIndex.vue?vue&type=script&lang=js"
export * from "./MobileIndex.vue?vue&type=script&lang=js"
import style0 from "./MobileIndex.vue?vue&type=style&index=0&id=2bc194e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc194e1",
  null
  
)

export default component.exports